<style>
  .disabled {
    pointer-events: none;
  }
</style>

<div class="{{ className }}" [ngClass]="{ disabled: isViewOnly === true }">
  <div class="survey-number">
    <strong>{{ sequenceNumber }}</strong>
  </div>
  <div class="survey-details">
    <p>
      <strong>{{ questionHead }}</strong> | {{ questionDescription }}
    </p>
    <ng-content *ngIf="!hasNumbers"></ng-content>
    <mat-button-toggle-group
      *ngIf="hasNumbers"
      name="Survey Count"
      aria-label="Survey Count"
    >
      <mat-button-toggle
        *ngFor="let item of countArray"
        (click)="clickEvent(item.label)"
        >{{ item.label }}</mat-button-toggle
      >
    </mat-button-toggle-group>
  </div>
  <div class="survey-delete-btn">
    <itb-icon
      *ngIf="!isViewOnly"
      [tooltipText]="tooltipText"
      [className]="'delete-r'"
      (onClickHandler)="onDelete()"
    ></itb-icon>
  </div>
</div>
